
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import CarNumber from "@/components/CarNumber.vue";
  import {IHome} from "@/modules/Home/interfaces/home.interface";
  import {bus} from "@/plugins/bus";
  import FormBuilderField from "@/modules/FormBuilder/components/FormBuilderField.vue";
  import {IFormBuilder} from "@/modules/FormBuilder/interfaces/form-builder.interface";
  import {corpRequest} from "@/modules/Corps/resources/corp.resource";

  enum ValidateStatus {
    Success = 'success',
    Error = 'error',
  }

  @Component({
    components: {
      AppDialog,
      CarNumber,
      FormBuilderField,
    },
  })
  export default class GetAccessPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'home', dialogName: 'getAccess' };
    refField = { prop: 'refModel', type: IFormBuilder.FieldType.Input, label: 'Введите реферальный код', };
    refModel = null;
    message = '';
    validateStatus: ValidateStatus | null = null;
    refCode = '';
    validateStatuses = ValidateStatus;

    validateInput() {
      // https://example.com?ref=123 - url for tests.
      const input = this.refModel.trim();

      // Case 1: It's just a number (digits only)
      if (/^\d+$/.test(input)) {
        this.message = ``;
        this.refCode = input;
        this.validateStatus = ValidateStatus.Success;
        return;
      }

      // Case 2: It's a URL with numeric ref parameter
      try {
        // Add https:// if missing
        const urlStr = input.includes('://') ? input : `https://${input}`;
        const url = new URL(urlStr);
        const refValue = url.searchParams.get('ref');

        if (refValue && /^\d+$/.test(refValue)) {
          this.message = ``;
          this.refCode = refValue;
          this.validateStatus = ValidateStatus.Success;
          return
        }

        this.message = "Ссылка должена содержать код в параметре 'ref'";
        this.validateStatus = ValidateStatus.Error;
      }
      catch (e) {
        this.message = "Значение должно содержать ссылку с реферальным кодом или сам реферальный код";
        this.validateStatus = ValidateStatus.Error;
      }
    }

    async updateRefCode() {
      const response = await corpRequest.changeCorp({ refCode: this.refCode });
      if (response.success) {
        this.$notify({
          title: 'Успешно',
          message: 'Доступ открыт',
          type: 'success'
        });
        bus.$emit(IHome.EmitterEvents.UpdateCarInfo);
        await this.closeDialog();
      }
    }

    async closeDialog() {
      this.$refs.appDialog.onClose();
    }
  }
